import React, { createContext, useContext } from 'react';

import type VistaprintAuth from '@vp/auth';
import { useIdentity } from '@vp/ubik-context';

interface IAuthContext {
  isInitialized: boolean;
  authorizationHeader?: string;
  shopperId?: string;
  auth?: VistaprintAuth;
}

const defaultAuthContext: IAuthContext = {
  isInitialized: false,
};

const AuthContext = createContext<IAuthContext>(defaultAuthContext);

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const { auth, isIdentityInitialized } = useIdentity();

  return (
    <>
      <AuthContext.Provider value={calculateAuthContext(auth, isIdentityInitialized)}>
        {children}
      </AuthContext.Provider>
    </>
  );
};

function calculateAuthContext(auth: VistaprintAuth, isIdentityInitialized: boolean): IAuthContext {
  return {
    isInitialized: isIdentityInitialized,
    authorizationHeader: auth?.getAuthorizationHeader?.(),
    shopperId: auth?.getCanonicalId?.(),
    auth: auth,
  };
}

export const useAuthContext = () => useContext(AuthContext);
